/* unplugin-vue-components disabled */import { render } from "./item-pwco.vue?vue&type=template&id=31d9d06b"
import script from "./item-pwco.vue?vue&type=script&lang=js"
export * from "./item-pwco.vue?vue&type=script&lang=js"

import "./item-pwco.vue?vue&type=style&index=0&id=31d9d06b&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__